module.exports = __webpack_public_path__ + "img/logo_reverse.4b69f6e9.png";